import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useEquipmentStore } from "../store/equipment";
import { TranslationMessagesContext } from "../util/Translations";
import { IonText } from "@ionic/react";
import EquipmentCards from "./EquipmentCards";
import { maxResults } from "../hooks/useQueryExec";
import Fuse from "fuse.js";

export default function DownloadedEquipments() {
  const downloadedEquip = useEquipmentStore(
    (state) => state.downloadedEquipments
  );
  const { translatedMessages } = useContext(TranslationMessagesContext);
  const [searchText, setSearchText] = useState("");

  const allRows = useMemo(
    () => downloadedEquip.flatMap((d) => d.row),
    [downloadedEquip]
  );
  const [filteredRows, setFilteredRows] = useState(allRows);

  useEffect(() => {
    setFilteredRows(allRows);
  }, [allRows]);

  const hasDownloadedEquip = downloadedEquip.length > 0;

  const fuse = useMemo(
    () =>
      new Fuse(allRows, {
        keys: ["Columns.Value"],
        includeScore: true,
        minMatchCharLength: 2,
        threshold: 0.5,
        shouldSort: true,
      }),
    [allRows]
  );

  const handleFilter = useCallback(
    async (queryString: string) => {
      if (queryString) {
        const res = fuse.search(queryString);
        setFilteredRows(res.map((r) => r.item).slice(0, maxResults));
      } else {
        setFilteredRows(allRows.slice(0, maxResults));
      }
      setSearchText(queryString);
    },
    [allRows, fuse]
  );

  return (
    <>
      {hasDownloadedEquip && (
        <EquipmentCards
          allRows={allRows}
          filteredRows={filteredRows}
          filterString={searchText}
          onFilter={handleFilter}
        />
      )}
      <IonText
        hidden={hasDownloadedEquip}
        color={"default"}
        style={{ padding: "16px", display: "inline-block" }}
      >
        {translatedMessages["NoResultsFound"]?.MessageText ||
          "No results found."}
      </IonText>
    </>
  );
}
